//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SUPERVISORS from '@/constants/supervisor'
import CircularButton from '@/components/Shared/CircularButton.vue'
import ModalAssignedCollaborators from './ModalAssignedCollaborators.vue'
import ModalRemoveSupervisor from './ModalRemoveSupervisor.vue'
import ModalRemoveSupervisorWithCollaborators from './ModalRemoveSupervisorWithCollaborators.vue'
import ModalAssignSupervisors from './ModalAssignSupervisors.vue'

export default {
  name: 'SupervisorsList',
  components: {
    ModalAssignedCollaborators,
    ModalRemoveSupervisor,
    ModalRemoveSupervisorWithCollaborators,
    ModalAssignSupervisors,
    CircularButton,
  },
  props: {
    filter: {
      default: '',
      type: String,
    },
    filterByInvitation: {
      default: null,
      type: Number || null,
    },
    supervisorsData: {
      default: () => [],
      type: Array,
    },
    allRowschecked: {
      default: () => null,
      type: Boolean,
    },
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      invitationStatus: SUPERVISORS.INVITATION_STATUS,
      checkedRows: [],
      paginationSize: 6,
      currentPage: 1,
      actions: [
        {
          label: this.$t(
            'projects.detail.supervisors.table.actionItems.validationReminder'
          ),
          key: 'validationReminder',
        },
        {
          label: this.$t(
            'projects.detail.supervisors.table.actionItems.resendInvitation'
          ),
          key: 'resendInvitation',
        },
        {
          label: this.$t(
            'projects.detail.supervisors.table.actionItems.viewCollaborators'
          ),
          key: 'viewCollaborators',
        },
        {
          label: this.$t(
            'projects.detail.supervisors.table.actionItems.removeFromProject'
          ),
          key: 'removeFromProject',
        },
      ],
      isAssignedCollaboratorsVisible: false,
      collaborators: [],
      isModalRemoveSupervisorVisible: false,
      isModalRemoveSupervisorWithCollaboratorsVisible: false,
      isModalAssignSupervisorsVisible: false,
      removeSupervisorData: {},
      unassignedCollaborators: [],
      supervisorsOptions: [],
      windowWidth: window.innerWidth,
      progressSortOrder: 'desc',
      supervisors: [],
    }
  },
  computed: {
    filteredSupervisors() {
      const searchText = this.filter ? this.filter.trim().toLowerCase() : null
      const selectedInvitation = this.filterByInvitation

      if (!searchText && selectedInvitation === null) {
        return this.supervisors
      }

      return this.supervisors.filter((supervisor) => {
        let matchesSearchText = false
        if (searchText) {
          const name = (supervisor.names || '').toLowerCase()
          const lastname = (supervisor.lastnames || '').toLowerCase()
          const identificationNumber = (
            supervisor.identification_number || ''
          ).toLowerCase()

          matchesSearchText =
            name.includes(searchText) ||
            lastname.includes(searchText) ||
            identificationNumber.includes(searchText)
        }

        let matchesSelectedInvitation = false
        if (selectedInvitation !== null) {
          matchesSelectedInvitation =
            supervisor.invitation_active === selectedInvitation
        }

        if (searchText && selectedInvitation !== null) {
          return matchesSearchText && matchesSelectedInvitation
        } else if (searchText) {
          return matchesSearchText
        } else if (selectedInvitation !== null) {
          return matchesSelectedInvitation
        }
        return false
      })
    },
    isMobile() {
      return this.windowWidth < 768
    },
  },
  watch: {
    allRowschecked() {
      this.toggleCheckVisibleRows()
    },
    supervisorsData(newData) {
      this.supervisors = newData.slice().sort((a, b) => {
        return a.progress < b.progress ? 1 : -1
      })
      this.isAllCheck(this.checkedRows)
    },
    filteredSupervisors() {
      this.isAllCheck(this.checkedRows)
    },
  },
  methods: {
    availableItems(row) {
      return this.actions.filter((item) => {
        switch (item.key) {
          case 'validationReminder':
            return this.validationReminderAvailability(row)
          case 'resendInvitation':
            return this.resendInvitationAvailability(row)
          default:
            return true
        }
      })
    },
    validationReminderAvailability(row) {
      return (
        row.collaborators.length > 0 &&
        !row.invitation_active &&
        row.progress < 100
      )
    },
    resendInvitationAvailability(row) {
      return row.invitation_active
    },
    getClassByStatus(isActive) {
      if (isActive) {
        return SUPERVISORS.INVITATION_STATUS.ACTIVE.class
      }
      return SUPERVISORS.INVITATION_STATUS.INACTIVE.class
    },
    getNameByStatus(isActive) {
      if (isActive) {
        return SUPERVISORS.INVITATION_STATUS.ACTIVE.name
      }
      return SUPERVISORS.INVITATION_STATUS.INACTIVE.name
    },
    isAllCheck(checkedList) {
      const checkeableVisibles = this.getCurrentPageCheckeableRows()
      this.emitMainCheckState(checkeableVisibles)
      if (
        checkeableVisibles.length > 0 &&
        checkeableVisibles.every((cv) => checkedList.includes(cv))
      ) {
        this.$emit('is-all-checked', true)
      } else {
        this.$emit('is-all-checked', false)
      }
    },
    onCheck(checkedList) {
      this.$emit('checked-rows', checkedList)
      this.isAllCheck(checkedList)
    },
    pageChanged(page) {
      this.currentPage = page
      this.isAllCheck(this.checkedRows)
    },
    sortChanged(field, order) {
      this.progressSortOrder = order
      this.isAllCheck(this.checkedRows)
    },
    getCurrentPageCheckeableRows() {
      const start = (this.currentPage - 1) * this.paginationSize
      const end = start + this.paginationSize
      return this.filteredSupervisors
        .slice(start, end)
        .filter(
          (row) =>
            row.invitation_active === SUPERVISORS.INVITATION_STATUS.ACTIVE.value
        )
    },
    emitMainCheckState(checkableList) {
      if (checkableList.length === 0) {
        this.$emit('disable-main-check', true)
      } else {
        this.$emit('disable-main-check', false)
      }
    },
    toggleCheckVisibleRows() {
      const checkeableVisibles = this.getCurrentPageCheckeableRows()
      this.emitMainCheckState(checkeableVisibles)
      const allSelected = checkeableVisibles.every((row) =>
        this.checkedRows.includes(row)
      )

      if (allSelected) {
        this.checkedRows = this.checkedRows.filter(
          (row) => !checkeableVisibles.includes(row)
        )
      } else {
        const newChecked = [
          ...this.checkedRows,
          ...checkeableVisibles.filter(
            (row) => !this.checkedRows.includes(row)
          ),
        ]
        this.checkedRows = newChecked
      }
      this.onCheck(this.checkedRows)
    },
    toggleAssignedCollaboratorsModal() {
      this.isAssignedCollaboratorsVisible = !this.isAssignedCollaboratorsVisible
    },
    getAssignedCollaboratorsModalClose(isClose) {
      if (isClose) this.toggleAssignedCollaboratorsModal()
    },
    viewCollaboratorsAction(row) {
      this.collaborators = row.collaborators.map((col) => {
        return { name: `${col.names} ${col.lastnames}` }
      })
      this.toggleAssignedCollaboratorsModal()
    },
    async resendInvitationAction(row) {
      return await this.$repository.invitation.supervisorReminderInvitation({
        usersIds: [row.user],
        projectId: this.project.id,
      })
    },
    async validationReminderAction(row) {
      return await this.$repository.invitation.toSupervisorsReminder({
        supervisor_id: row.user,
      })
    },
    removeFromProjectAction(row) {
      const supervisor = {
        name: `${row.names} ${row.lastnames}`,
        id: row.user,
      }
      if (row.collaborators.length === 0) {
        this.removeSupervisorData = supervisor
        this.toggleModalRemoveSupervisor()
      } else {
        supervisor.collaborators = row.collaborators.map((col) => {
          return {
            name: `${col.names} ${col.lastnames}`,
            id: col.id,
          }
        })
        this.removeSupervisorData = supervisor
        this.toggleModalRemoveSupervisorWithCollaborators()
      }
    },
    onItemAction(key, row) {
      switch (key) {
        case 'viewCollaborators':
          this.viewCollaboratorsAction(row)
          break
        case 'resendInvitation':
          this.resendInvitationAction(row)
          break
        case 'validationReminder':
          this.validationReminderAction(row)
          break
        case 'removeFromProject':
          this.removeFromProjectAction(row)
          break
      }
    },
    goToCollaborators() {
      this.toggleAssignedCollaboratorsModal()
      this.$emit('go-to-collaborators')
    },
    toggleModalRemoveSupervisor() {
      this.isModalRemoveSupervisorVisible = !this.isModalRemoveSupervisorVisible
    },
    toggleModalRemoveSupervisorWithCollaborators() {
      this.isModalRemoveSupervisorWithCollaboratorsVisible = !this
        .isModalRemoveSupervisorWithCollaboratorsVisible
    },
    toggleModalAssignSupervisors() {
      this.isModalAssignSupervisorsVisible = !this
        .isModalAssignSupervisorsVisible
    },
    async onRemoveSupervisor(supervisorId) {
      await this.removeSupervisor(supervisorId)
      this.toggleModalRemoveSupervisor()
    },
    async removeSupervisor(supervisorId) {
      this.$store.commit('loading', true)
      try {
        await this.$repository.user.removeSupervisorFromProject({
          project: this.project.id,
          supervisor: supervisorId,
        })
        this.$store.commit('loading', false)
        this.$emit('refresh-supervisor')
        this.$buefy.notification.open({
          message: `<p style="margin-top: 10px">${this.$t(
            'projects.detail.supervisors.notifications.removeSupervisor'
          )}</p>`,
          type: 'is-success',
          hasIcon: true,
          duration: 5000,
        })
        return true
      } catch (e) {
        this.$store.commit('loading', false)
        this.$buefy.notification.open({
          message: e.message,
          type: 'is-danger',
          duration: 5000,
        })
        return false
      }
    },
    async onRemoveSupervisorWithCollaborators(supervisor) {
      this.toggleModalRemoveSupervisorWithCollaborators()
      this.unassignedCollaborators = supervisor.collaborators

      const removedSupervisor = await this.removeSupervisor(supervisor.id)

      if (removedSupervisor) {
        this.supervisorsOptions = this.supervisors.filter(
          (sv) => sv.user !== supervisor.id
        )
        this.toggleModalAssignSupervisors()
        this.$emit('refresh-supervisor')
      }
    },
    onAssignLater(collaborators) {
      this.toggleModalAssignSupervisors()
      this.$emit('assign-collaborators-later', collaborators)
    },
    async onAssignSupervisors(supervisorsAssigned) {
      this.$store.commit('loading', true)

      try {
        await this.$repository.supervisorAssignments.updateMassiveSupervisorsWithCollaborators(
          {
            projectId: this.project.id,
            assignments: supervisorsAssigned,
          }
        )

        const newSupervisorIds = [
          ...new Set(supervisorsAssigned.map((sv) => sv.supervisorId)),
        ]
        await Promise.all(
          newSupervisorIds.map((supervisorId) =>
            this.$repository.projectRoles.updateValidationStatus(
              this.project.id,
              supervisorId,
              true
            )
          )
        )
        this.$store.commit('loading', false)
        this.$emit('refresh-supervisor')
        this.$buefy.notification.open({
          message: `<p style="margin-top: 10px">${this.$t(
            'projects.detail.supervisors.notifications.assignSupervisor'
          )}</p>`,
          type: 'is-success',
          hasIcon: true,
          duration: 5000,
        })
      } catch (e) {
        this.$store.commit('loading', false)
        this.$buefy.notification.open({
          message: e.message,
          type: 'is-danger',
          duration: 5000,
        })
      }
      this.toggleModalAssignSupervisors()
    },
    clearSelecetedRows() {
      this.checkedRows = []
      this.$emit('checked-rows', [])
      this.isAllCheck(this.checkedRows)
    },
    setProgressValue(rawProgress) {
      if (rawProgress === 0) {
        return 0
      }
      if (this.isMobile) {
        return rawProgress < 12 ? 12 : rawProgress
      } else {
        return rawProgress < 8 ? 8 : rawProgress
      }
    },
    setProgressStyle(rawProgress) {
      const defaultStyle = { '--value': rawProgress / 2 + '%' }

      if (this.isMobile) {
        return rawProgress < 12 ? { '--value': '6%' } : defaultStyle
      } else {
        return rawProgress < 8 ? { '--value': '4%' } : defaultStyle
      }
    },
  },
}
